/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
import { params, shape, string, useDataModel } from '@thd-nucleus/data-sources';
import { useImpression } from '@thd-olt-component-react/impression';

const { string: stringProp, node } = proptypes;

export const ProductLink = ({
  itemId = '',
  target = '_self',
  text = null,
  children = null,
}) => {

  const { data } = useDataModel('product', {
    variables: {
      itemId,
    }
  });

  const { additionalData = {} } = useImpression({
    data: {
      id: itemId,
      component: 'ProductLink',
      name: 'ProductLink',
      position: 0
    }
  });

  const { parent } = additionalData || {};

  if (!children && !text) return null;

  const product = data?.product || {};

  const { canonicalUrl } = product?.identifiers || {};

  if (!canonicalUrl) return null;

  const handleClick = () => {

    const productLinkEventData = {
      podAction: 'product link',
      podAnchorSku: itemId,
      target,
      parent
    };
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('product-pod-v7.click', productLinkEventData);
    }
  };

  return (
    <div className="sui-my-1 sui-text-info">
      <a
        href={canonicalUrl}
        target={target}
        onClick={handleClick}
      >
        {children || text}
      </a>
    </div>
  );
};

ProductLink.propTypes = {
  itemId: stringProp,
  target: stringProp,
  text: stringProp,
  children: node,
};


ProductLink.dataModel = {
  product: params({
    itemId: string().isRequired(),
  }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      canonicalUrl: string(),
    }),
  }),
};

ProductLink.displayName = 'ProductLink';
